import $ from 'jquery.js';
import { setupLayout } from 'common.js';
import { ajaxPost, ajaxGet } from 'network/network-old.js';
import 'jquery-components/bootstrap-popover';
import 'jquery-components/bootstrap-collapse';
import 'jquery-components/bootstrap-datepicker';
import 'jquery-components/bootstrap-datetimepicker';
import 'jquery-components/bootstrap-validator';
import 'jquery-ui/ui/widgets/slider';
import { fillBootstrapSelectWithAjax, setSelectpickerVal } from 'jquery-components/bootstrap-select';

// Настройка страницы поиска трансфера
function setupTransferSearch(maxAdultCount, maxChildCount) {
    $(function () {
        // Выбор количества детей
        var showHideChildrenAges = function () {
            var childCount = parseInt($(".child-count.selectpicker").selectpicker("val"));
            $(".child").removeClass("dont-show");
            for (var child = childCount + 1; child <= maxChildCount; child++)
                $(".child" + child.toString()).addClass("dont-show");
        };
        $(".child-count.selectpicker").on("changed.bs.select", showHideChildrenAges);
        showHideChildrenAges();

        // Настройка полей выезда и заезда
        var connectFromToSelects = false;
        for (var i = 0; i < 2; i++) {
            (function (i) {
                var dir = (i == 0) ? "From" : "To";
                var $city = $("#city" + dir + "Id");
                var $country = $("#country" + dir + "Id");
                var $type = $("#type" + dir + "Id");
                var $place = $("#place" + dir + "Id");
                $city.prop("disabled", true);
                // Выбор мест
                var selectPlaces = function () {
                    var cityId = $city.selectpicker("val");
                    var typeId = $type.selectpicker("val");
                    if (!cityId || !typeId) {
                        $place.selectpicker("val", null);
                        $place.prop("disabled", true);
                    } else {
                        $place.prop("disabled", false);
                        fillBootstrapSelectWithAjax($place.attr("id"), "Transfer/GetTransferPoints", { CityId: cityId, TransferPointTypeId: typeId }, prevPlaceId[i]);
                    }
                };
                // Выбор страны
                $country.on("changed.bs.select", function (e) {
                    var countryId = $country.selectpicker("val");
                    if (countryId) {
                        $city.prop("disabled", false);
                        fillBootstrapSelectWithAjax($city.attr("id"), "Transfer/GetCities", { CountryId: countryId }, prevCityId[i]);
                        if (dir == "From" && connectFromToSelects) {
                            setSelectpickerVal($("#countryToId"), countryId);
                        }
                    } else {
                        $city.prop("disabled", true).selectpicker("refresh");
                    }
                });
                $city.on("changed.bs.select", function (e) {
                    selectPlaces();
                    var cityId = $city.selectpicker("val");
                    if (connectFromToSelects && dir == "From" && cityId && !$("#cityToId").selectpicker("val")) {
                        if ($("#countryFromId").selectpicker("val") == $("#countryToId").selectpicker("val")) {
                            setSelectpickerVal($("#cityToId"), cityId);
                        }
                    }
                });
                $country.trigger("changed.bs.select");
                $city.trigger("changed.bs.select");
                $type.on("changed.bs.select", function (e) { selectPlaces(); });
                selectPlaces();
                // Выбор дат
                var dateOptions = {
                    language: language,
                    minDate: new Date(),
                    format: "L",
                    useCurrent: false,
                    pickTime: false
                };
                $(".input-group.date").datetimepicker(dateOptions);
                var dirTypeChanged = function () {
                    if (document.forms.bookingForm.dirType.value == "one") {
                        $(".date-backward").addClass("dont-show");
                        $(".date-backward input").removeAttr("required");
                    } else {
                        $(".date-backward.dont-show").removeClass("dont-show");
                        $(".date-backward input").attr("required", "required");
                    }
                };
                $("input[name='dirType']").change(dirTypeChanged);
                dirTypeChanged();
            })(i);
            connectFromToSelects = true;

            // Очистка формы
            var $forwardPicker = $(".date-forward .input-group");
            var $backwardPicker = $(".date-backward .input-group");
            $("#clearBtn").click(function (evt) {
                evt.preventDefault();
                for (var i = 0; i < 2; i++) {
                    (function (i) {
                        var dir = (i == 0) ? "From" : "To";
                        var $city = $("#city" + dir + "Id");
                        var $country = $("#country" + dir + "Id");
                        var $type = $("#type" + dir + "Id");
                        var $place = $("#place" + dir + "Id");
                        $place.selectpicker("val", null);
                        $city.selectpicker("val", null);
                        $country.selectpicker("val", null);
                        $place.trigger("changed.bs.select");
                        $city.trigger("changed.bs.select");
                        $country.trigger("changed.bs.select");
                    })(i);
                }
                $(".adult-count").selectpicker("val", 2);
                $(".child-count").selectpicker("val", 0);
                $(".child-count").trigger("changed.bs.select");
                $forwardPicker.data("DateTimePicker").setDate(null);
                $backwardPicker.data("DateTimePicker").setDate(null);
                $(".help-block.with-errors").empty();
            });

            // Обработка изменения дат
            var suppressDateChangeProcessing = false;
            $forwardPicker.on("dp.change", function () {
                if (suppressDateChangeProcessing) return;
                suppressDateChangeProcessing = true;
                if (document.forms.bookingForm.dirType.value == "one")
                    $backwardPicker.data("DateTimePicker").setDate(null);
                else {
                    var from = $forwardPicker.data("DateTimePicker").getDate();
                    var to = $backwardPicker.data("DateTimePicker").getDate();
                    if (from && to) {
                        var fromDay = from.startOf("day");
                        var toDay = to.startOf("day");
                        if (toDay.isBefore(fromDay)) {
                            from.add(1, 'd');
                            $backwardPicker.data("DateTimePicker").setDate(from);
                        }
                    }
                }
                $(".date-forward input,.date-backward input").trigger("change");
                suppressDateChangeProcessing = false;
            });
            $backwardPicker.on("dp.change", function () {
                if (suppressDateChangeProcessing) return;
                suppressDateChangeProcessing = true;
                var from = $forwardPicker.data("DateTimePicker").getDate();
                var to = $backwardPicker.data("DateTimePicker").getDate();
                if (from && to) {
                    var fromDay = from.startOf("day");
                    var toDay = to.startOf("day");
                    if (toDay.isBefore(fromDay)) {
                        to.add(-1, 'd');
                        $forwardPicker.data("DateTimePicker").setDate(to);
                    }
                }
                $(".date-forward input,.date-backward input").trigger("change");
                suppressDateChangeProcessing = false;
            });

        }
    });
}

// Обработка изменения фильтра
function transferSearchResultFilterChanged() {
    if (typeof transferSearchResultFilterChanged.timerId != "undefined")
        clearTimeout(transferSearchResultFilterChanged.timerId);
    transferSearchResultFilterChanged.timerId = setTimeout(transferSearchResultApplyFilter, 500);
}

// Фильтрация
function transferSearchResultApplyFilter() {
    // Получение фильтра
    const priceSliderValues = $("#TransferPrice .jqui-slider").slider("option", "values");
    const capSliderValues = $("#TransferCapacity .jqui-slider").slider("option", "values");
    const minSum = priceSliderValues[0], maxSum = priceSliderValues[1];
    const minCap = capSliderValues[0], maxCap = capSliderValues[1];
    const group = $("#typeTransfer .selectpicker").selectpicker("val");
    const isQueryValid = minSum <= maxSum && minCap <= maxCap;

    // Проход по всем строкам с фильтрацией
    var rows = $(".transfer-content tbody tr");
    for (var i = 0; i < rows.length; i++) {
        var row = $(rows[i]);
        row.addClass("dont-show");

        if (!isQueryValid)
            continue;

        const caps = row.attr('data-capacity').split(' ').map(function (x) { return parseInt(x) });
        if (!caps.find(function (x) { return minCap <= x && x <= maxCap }))
            continue;

        var price = parseFloat(row.attr("data-price"));
        if (price < minSum || price > maxSum)
            continue;
        if (group != "" && row.attr("data-tr-grp") != group)
            continue;
        row.removeClass("dont-show");
    }
    var totalFound = $(".transfer-content tbody tr:not(.dont-show)").length;
    $(".hotels-number .count").text(totalFound);
}


// Настройка страницы результатов поиска трансфера
function setupTransferSearchResult() {
    $(function () {
        const sliders = [
            { el: $('#TransferCapacity'), values: [transferFilterLimits.minCapacity, transferFilterLimits.maxCapacity] },
            { el: $('#TransferPrice'), values: [transferFilterLimits.minSum, transferFilterLimits.maxSum] },
        ];

        for (let i = 0; i < sliders.length; ++i) {
            const sliderData = sliders[i];
            const slider = $('.jqui-slider', sliderData.el);
            const min = sliderData.values[0];
            const max = sliderData.values[1];

            $(slider).slider({
                range: true,
                min: min,
                max: max,
                values: [min, max],
                slide: function (_, ui) {
                    $('.jqui-slider-from', sliderData.el).val(ui.values[0]);
                    $('.jqui-slider-to', sliderData.el).val(ui.values[1]);
                    transferSearchResultFilterChanged();
                },
            });

            const handleChange = function (isRight) {
                return function () {
                    let val1 = parseFloat($(this).val());

                    if (isNaN(val1)) {
                        val1 = isRight ? max : min;
                    }

                    slider.slider("values", isRight ? 1 : 0, val1);
                    transferSearchResultFilterChanged();
                }
            };

            $('.jqui-slider-from', sliderData.el).on('change', handleChange(false));
            $('.jqui-slider-to', sliderData.el).on('change', handleChange(true));
        }

        $("#transferCapacity .selectpicker").on("changed.bs.select", transferSearchResultFilterChanged);
        $("#typeTransfer .selectpicker").on("changed.bs.select", transferSearchResultFilterChanged);

        // Описание трансфера
        $(".transfer-content .readmore").click(function (evt) {
            evt.preventDefault();

            var $row = $(this).closest("tr");
            var args = [
                $row.attr("data-tr-id"),
                $row.attr("data-tr-tp-id"),
                $row.attr("data-tr-id-back"),
                $row.attr("data-tr-tp-id-back"),
                $(this).closest("tr")
            ];

            if (showTransferDescription.apply(null, args)) {
                var historyArgs = args.slice(0, 4);
                var historyUrl = document.documentURI + "&xfr=" + encodeURIComponent(JSON.stringify(historyArgs));
                history.pushState({ page: "TRANSFER", args: historyArgs }, "", historyUrl);
            }
        });

        // Добавление в корзину
        $(".cart-btn").click(function(evt){
            evt.preventDefault();
            addTransferToCart($(this).closest("tr[data-serialized]"));
        });

        window.addEventListener("popstate", function (e) {
            if (!e.state || !e.state.page)
                return;

            if (e.state.page === "TRANSFER") {
                showTransferDescription.apply(null, e.state.args);
                e.preventDefault();
            } else if (e.state.page === "TRANSFER_SEARCH") {
                closeTransferDescription();
                e.preventDefault();
            }
        });

        // Вызов должен быть в конце.
        loadRequestedPage();
    });
}

function loadRequestedPage() {
    try {
        var url = new URL(document.documentURI);
        if (url.searchParams.has("xfr")) {
            var args = JSON.parse(url.searchParams.get("xfr"));
            history.replaceState({ page: "TRANSFER", args: args }, "");
            showTransferDescription.apply(null, args);
        } else {
            history.replaceState({ page: "TRANSFER_SEARCH" }, "");
        }
    } catch (err) {
        console.error("Unable to load requested page", err);
    }
}

function showTransferDescription(transferId, transferTypeId, transferBackId, transferBackTypeId, $row) {
    // Для отображения деталей трансфера необходимы данные из поиска. В частности нужна цена
    // трансфера. Сервер не возвращает этих данных в ответе при запросе описания, поэтому
    // заполняем их на основе имеющихся данных вручную.
    if (!$row) {
        var selector = "tr[data-tr-id=\""
            .concat(transferId, "\"][data-tr-tp-id=\"")
            .concat(transferTypeId, "\"][data-tr-id-back=\"")
            .concat(transferBackId, "\"][data-tr-tp-id-back=\"")
            .concat(transferBackTypeId, "\"]");
        $row = $(selector);
    }

    var data = {
        transferId: transferId,
        transferTypeId: transferTypeId,
        transferBackId: transferBackId,
        transferBackTypeId: transferBackTypeId
    };

    if (!$($row).length) {
        console.error("Transfer not found", data);
        return false;
    }

    ajaxGet(appBase + "Transfer/TransferDescription", $.param(data, true), function (res) {
        $("#mainPageContent .transfer-form").hide();
        $("#mainPageContent").append(res);
        // Копирование элементов - вёрстка достаточно странная, предполагалась как отдельная страница
        // Поэтому чтобы не перезапрашивать у сервера много данных, которые и так есть, они просто копируются
        var sels = [".steps", ".hotel-info"];
        for (var i = 0; i < sels.length; i++)
            $("#mainPageContent .transfer-single " + sels[i]).html($("#mainPageContent .transfer-form " + sels[i]).html());
        
        for(var dir=0;dir<2;dir++){
            var dirName = dir == 0 ? "fwd" : "back";
            $("#mainPageContent .transfer-single ." + dirName + " h3").text($(".transfer-form h3 span."+dirName).text());
            $("#mainPageContent .transfer-single ." + dirName + " .title-name").text($row.attr(dir==0?"data-name":"data-name-back"));
            $("#mainPageContent .transfer-single ." + dirName + " .title-price").text($row.attr("data-price-"+dirName));
        }

        // Прокрутка к началу описания
        $("html, body").animate({ scrollTop: $(".transfer-body h3").offset().top });
        // Закрытие
        $(".transfer-single .back-to-search").click(function (backEvt) {
            backEvt.preventDefault();
            navigateToSearch();
        });
    });

    return true;
}

function closeTransferDescription() {
    $("#mainPageContent .transfer-single").remove();
    $("#mainPageContent .transfer-form").show();
}

function navigateToSearch() {
    var url = new URL(document.documentURI);
    url.searchParams.delete("xfr");

    closeTransferDescription();
    history.pushState({ page: "TRANSFER_SEARCH" }, "", url.toString());
}

// Добавление трансфера в корзину
function addTransferToCart($transfer, replaceCart) {
    var cartData = {
        searchParamsSerialized: searchParamsSerialized,
        transferSerialized: $transfer.attr("data-serialized")
    };
    if (replaceCart)
        cartData.replaceCart = true;
    ajaxPost(appBase + "Transfer/AddToCart", cartData, function (data) {
        if (data && data.errorCode && data.errorCode.indexOf('CART_CONFLICT') === 0 && window.showCartConflictModal) {
            var reason = data.errorCode === 'CART_CONFLICT_CURRENCY' ? 'currency' : 'service';
            window.showCartConflictModal({
                reason: reason,
                onReplace: function () { addTransferToCart($transfer, true); }
            });
            return;
        }
        window.location = appBase + "Cart";
    });
}

export {
    setupTransferSearch,
    setupTransferSearchResult,
    setupLayout,
}
